import { withShowIf } from "../../../../../../../../../../components/with-show-if/with-show-If.component";
import { TextField } from "../../../../../../../../../../features/forms/fields/text-field/text-field.component";
import React from "react";
import { FlyerDetailPageFormPositionGetProductImageUrlProps } from "./flyer-detail-page-form-position-get-product-image-url.props";

export const FlyerDetailPageFormPositionGetProductImageUrl = withShowIf(
  (props: FlyerDetailPageFormPositionGetProductImageUrlProps) => (
    <TextField
      form={props.form}
      label={`"Get" Product Image Location`}
      name={`${props.copyFieldPath}.getProductImage`}
      userPermissions={props.userPermissions}
    />
  )
);
